import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { Map as ImmutableMap, Record } from 'immutable';
import { getMetadataValue } from '../../../utils/frameworkBuilder';
import { isUnifiedEventObjectTypeId } from 'customer-data-filters-ui/filterQueryFormat/ObjectTypeId';
import Adapter from './Adapter';
import HttpAdapterConfig from '../adapterConfigs/HttpAdapterConfig';
export const FrameworkBuilderTypeMetadataRecord = Record({
  categoryGroupLabel: '',
  categoryGroupName: '',
  fullyQualifiedName: '',
  gates: [],
  label: '',
  objectTypeId: undefined,
  scopes: [],
  requiredObjectTypeIds: []
});
export class UnifiedEventsAdapterConfig extends HttpAdapterConfig {
  getCacheKey() {
    return 'UNIFIED_EVENTS';
  }
  isAssetFamilySupported(assetFamily) {
    return assetFamily === DSAssetFamilies.UNIFIED_EVENT;
  }
  fetchData(httpClient) {
    return httpClient('framework-builder/v1/read/metadata/types/filtersFrontEnd');
  }
  formatData(unifiedEvents) {
    return Object.entries(unifiedEvents).reduce((acc, [key, {
      metadata
    }]) => {
      const objectTypeId = getMetadataValue(metadata.objectTypeId);
      if (isUnifiedEventObjectTypeId(objectTypeId)) {
        const {
          categoryGroupLabel,
          categoryGroupName,
          gates,
          singularForm,
          scopes
        } = metadata;
        return acc.set(objectTypeId, FrameworkBuilderTypeMetadataRecord({
          categoryGroupLabel: getMetadataValue(categoryGroupLabel),
          categoryGroupName: getMetadataValue(categoryGroupName),
          fullyQualifiedName: key,
          gates: getMetadataValue(gates) || [],
          label: getMetadataValue(singularForm) || key,
          scopes: getMetadataValue(scopes) || [],
          objectTypeId,
          requiredObjectTypeIds: getMetadataValue(metadata.requiredObjectTypeIds) || []
        }));
      }
      return acc;
    }, ImmutableMap());
  }
}
export default Adapter.makeFromConfig(UnifiedEventsAdapterConfig);